import { render } from "./ServicesCard.vue?vue&type=template&id=e19a87c8&scoped=true"
import script from "./ServicesCard.vue?vue&type=script&lang=js"
export * from "./ServicesCard.vue?vue&type=script&lang=js"

import "./ServicesCard.vue?vue&type=style&index=0&id=e19a87c8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e19a87c8"]])

export default __exports__